// @flow

import * as React from 'react';
import {useEffect} from 'react';

type ScrollHandlerFunction = (position: number) => any;

export const useScrollEffect = (
  ref: React.ElementRef<any>,
  onScroll: ScrollHandlerFunction,
) => {
  return useEffect(() => {
    const current = ref?.current;
    if (current) {
      const handleScroll = () => onScroll(current.scrollTop);
      current.addEventListener('scroll', handleScroll);
      return () => current.removeEventListener('scroll', handleScroll);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ // TODO: use correct dependencies
  }, [ref]);
};
